import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import de from './locales/de'
import en from './locales/en'

// Get saved language or use browser language
const savedLanguage = localStorage.getItem('language')
const browserLanguage = navigator.language.split('-')[0]
const defaultLanguage = savedLanguage || (browserLanguage === 'de' || browserLanguage === 'en' ? browserLanguage : 'de')

i18n
  .use(initReactI18next)
  .init({
    resources: {
      de,
      en,
    },
    lng: defaultLanguage,
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
